import React from "react"
import { Layout,Row, Col} from "antd"
import { SettingTwoTone, ToolTwoTone } from "@ant-design/icons";
import { useTranslation } from 'react-i18next';
import './underMaintenance.scss';

const { Content } = Layout

const UnderMaintenance: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="under-maintenance">
      <Layout>
        <Content>
          <Row className="content-row-height" justify="center" align="middle">
            <Col xs={24} sm={20} md={16} lg={12} xl={10}>
                <div className="under-maintenance-content">
                  <div className="under-maintenance-barrier" />
                    <div className="under-maintenance-wrapper">
                      <span className="under-maintenance-icon spin-setting">
                        <SettingTwoTone twoToneColor="#faad14" className="under-maintenance-icon" />
                      </span>
                      <div className="under-maintenance-row">
                        <ToolTwoTone twoToneColor="#faad14" className="under-maintenance-tool-icon" />
                        <span className="under-maintenance-text">{t('common.under_maintenance')}</span>
                      </div>
                    </div>
                </div>
            </Col>
          </Row>
        </Content>
      </Layout>
    </div>
  )
}

export default UnderMaintenance;
